import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddLocationMasterModal = ({ isAddOpen, onAddClose, formData, setFormData, branches }) => {
  if (!isAddOpen) return null;


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    console.log("Form Submit Triggered");
    console.log("Form Data:", formData);
  
    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      const payload = {
        locationBranch: formData.locationBranch,
        location: formData.location,
      };
  
      console.log("Payload being sent to server:", payload);
  
      const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/veh_location_add`, payload);
  
      console.log("Server response:", response.data);
  
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Inserted!",
          text: "Location inserted successfully.",
        });
        onAddClose();
        window.location.reload();
      } else {
        console.warn("Insert failed, no 'success' in response:", response.data);
        Swal.fire({
          icon: "error",
          title: "Insert Failed",
          text: response.data.message || "Unknown error.",
        });
      }
  
    } catch (error) {
  console.error("Error inserting location:", error);

  if (error.response && error.response.data && error.response.data.message) {
    Swal.fire({
      icon: "error",
      title: "Insert Failed",
      text: error.response.data.message,  // <-- duplicate message will show here
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Insert failed. Please try again.",
    });
  }
}

  };
  
  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onAddClose} style={{position: "initial"}}>&times;</button>
        </div>
        <h3>Add New Location List </h3>
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
            <div className="form-group">
                <label>Branch :</label>
                <select name="locationBranch" value={formData.locationBranch} onChange={handleChange} className="branch-select">
          <option value="">Select Branch</option>
          {branches.map((item) => (
            <option key={item.branchMaster_code} value={item.branchMaster_code}>
              {item.branchMaster_name}
            </option>
          ))}
        </select>
              </div> 
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Location :</label>
                <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
          />
              </div> 
            </div>


            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Save
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default AddLocationMasterModal;
